import {AnyTaskVariableDto} from '../types/entities/tasks';
import {v4 as uuidV4} from 'uuid';
import NumberVariableDto = App.DTOs.Tasks.Variables.NumberVariableDto;
import StringChoiceVariableDto = App.DTOs.Tasks.Variables.StringChoiceVariableDto;

export interface VariableType {
  translationKey: string;
  type: string;
  icon: string;
  create: () => AnyTaskVariableDto;
}

const variableTypes: VariableType[] = [
  {
    translationKey: 'numberVariable',
    type: 'Number',
    icon: 'numeric',
    create: (): NumberVariableDto => ({
      name: '',
      uuid: uuidV4(),
      type: 'Number',
      min: 0,
      max: 10,
      shift: 0,
      step: 1,
      scientificNotation: false,
      includeZero: true,
    }),
  },
  {
    translationKey: 'stringChoiceVariable',
    icon: 'text',
    type: 'StringChoice',
    create: (): StringChoiceVariableDto => ({
      name: '',
      uuid: uuidV4(),
      type: 'StringChoice',
      options: [''],
    }),
  },
];

export function useVariableTypeLibrary() {
  const isStringVariable = (value: AnyTaskVariableDto): value is StringChoiceVariableDto =>
    value.type === 'StringChoice';
  const isNumberVariable = (value: AnyTaskVariableDto): value is NumberVariableDto =>
    value.type === 'Number';

  return {
    variableTypes,
    isStringVariable,
    isNumberVariable,
  };
}
